// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"CreateBotProcess_backBtn__3SOw_","tabs":"CreateBotProcess_tabs__1m_ud","tabTitle":"CreateBotProcess_tabTitle__2Xr_G"};